/** Primary CTA pill used on the landing page (and matching actions elsewhere). */
export const loginButtonSx = {
	backgroundColor: "#FF9E00",
	color: "rgba(0, 0, 0, 0.87)",
	fontFamily: "Titillium Web, sans-serif",
	fontWeight: 600,
	fontSize: "15px",
	lineHeight: 1,
	letterSpacing: "0.46px",
	textTransform: "uppercase",
	height: "42px",
	minHeight: "42px",
	borderRadius: "999px",
	padding: "0 36px",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	border: "none",
	cursor: "pointer",
	boxShadow: `
		0px 24px 10px rgba(255, 157, 3, 0.01),
		0px 14px 8px rgba(255, 157, 3, 0.05),
		0px 6px 6px rgba(255, 157, 3, 0.09),
		0px 2px 3px rgba(255, 157, 3, 0.1)
	`,
	"&:hover": {
		backgroundColor: "#FF9E00",
		opacity: 0.9
	},
	"&:active": {
		backgroundColor: "#FF9E00",
		opacity: 0.8
	}
} as const;
